import React, { Component } from 'react';

// Graphql
import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

// React Final Form
import { Form, Field } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { FieldArray } from 'react-final-form-arrays';

// Material UI Imports
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';


// Material Icons Imports
import IconContentSend from '@material-ui/icons/Send';
import IconContentReset from '@material-ui/icons/DeleteSweep';
import IconContentRemB from '@material-ui/icons/RemoveCircle';

import { DatePicker } from 'material-ui-pickers';

import Supervisors from "./innerComponents/Supervisors";



// Assets imports
import '../styles/NewProject.css';
// Moment
import moment from 'moment';
import CustomLoader from './innerComponents/CustomLoader';

const fieldStyle = {
  minHeight: "72px",
  width: "100%",
};

const buttonStyle = {
  marginRight: 12,
};

const paperStyle = {
  // General styles for paper
  width: "60%",
  margin: "0 auto",
  height: "auto",
};

class NewProjectTmpForm extends Component {

  state = {
    description: '',
    url: '',
    dataSource: [],
    value: 1
  }


  _regionsItems(items) {
    return items.map((item, id) => (
      <MenuItem
        value={item.id}
        key={item.id}

      >{item.name}</MenuItem>
    ));
  }

  _createLink = async values => {

    const name = values.projectName
    const number = values.projectNumber
    const siteAddress = values.siteAddress
    const siteName = values.siteName
    const location = values.location
    const regionId = values.regionId
    const startDate = moment(values.startDate).format('YYYY-MM-DDTHH:mm:ss.SSS')
    const endDate = moment(values.endDate).format('YYYY-MM-DDTHH:mm:ss.SSS')
    const supervisors = values.supervisors
    const creatorId = localStorage.current_user

    let currentCreatedProjectId = null

    await this.props.postMutation({
      variables: {
        name,
        number,
        siteAddress,
        siteName,
        location,
        regionId,
        startDate,
        endDate,
        creatorId
      }
    }).then(({ data }) => {
      alert("Project '" + data.createProject.name + "' has been created successfully and supervisors will be invited.", data)
      currentCreatedProjectId = data.createProject.id
      //sentence to create the project invitations
      if (values.supervisors.length > 0) {
        supervisors.map((supervisor) => this._createProjectInvitation(currentCreatedProjectId, supervisor))
      }
      this.props.history.push({
        pathname: "/projects/list",
        state: { refetch: true }
      });
    }).catch((error) => {
      alert("Project Could not be created")
      console.log('there was an error sending the mutation', error);
    });
  }

  _createProjectInvitation(currentCreatedProjectId, supervisorId) {
    this.props.projectInvitationMutation({
      variables: {
        currentCreatedProjectId,
        supervisorId
      }
    }).then(({ data }) => {
      // alert("The Supervisor \"" + data.createProjectInvitation.user.name + "\" has been notified, with the project invitation: " + data.createProjectInvitation.id, data)
    }).catch((error) => {
      // alert("Project Invitation Could not be created")
      console.log('there was an error sending the mutation', error);
    });
  }


  render() {

    const required = value => (value ? undefined : 'Required field');

    const TextFieldAdapter = ({ input, meta, ...rest }) => (
      <TextField
        {...input}
        {...rest}
        onChange={(event) => input.onChange(event.target.value)}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    const DatePickerAdapter = ({ input, meta, ...rest }) => (
      <DatePicker
        {...input}
        {...rest}
        disableOpenOnEnter
        format="YYYY-MM-DD"
        invalidLabel=""
        onChange={(event) => input.onChange(event.format('YYYY-MM-DDTHH:mm:ss.SSS'))}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    const SelectedFieldAdapter = ({ input, meta, ...rest }) => (
      <TextField
        {...input}
        {...rest}
        select
        onChange={(event) => input.onChange(event.target.value)}
        error={meta.touched && meta.error !== undefined}
        helperText={meta.touched ? meta.error : ''}
      />
    );

    // Check if the query response is being loaded
    if (this.props.all_regions_query && this.props.all_regions_query.loading) {
      return <CustomLoader label={'Loading Regions'}/>
    }

    // Check if there were errrors
    if (this.props.all_regions_query && this.props.all_regions_query.error) {
      return <div> Regions Could not be loaded </div>
    }


    // Check if the query response is being loaded
    if (this.props.all_supervisors_query && this.props.all_supervisors_query.loading) {
      return <CustomLoader label={'Loading Supervisor'}/>
    }

    // Check if there were errrors
    if (this.props.all_supervisors_query && this.props.all_supervisors_query.error) {
      return <div> Supervisor Could not be loaded </div>
    }

    // Get the data to render it

    const all_regions = this.props.all_regions_query.regions;
    const all_supervisors = this.props.all_supervisors_query.users;

    const suggestions = all_supervisors.map(suggestion => ({
      value: suggestion.id,
      label: [suggestion.fullName, suggestion.email],
    }));

    return (
      <Paper style={paperStyle} elevation={1} >
        <div>
          <Form
            onSubmit={this._createLink}
            mutators={{
              ...arrayMutators
            }}
            initialValues={{ supervisors: [] }}
            render={({ handleSubmit, mutators: { push, pop, forEach }, reset, submitting, pristine, values, supervisors }) => (

              <form onSubmit={handleSubmit}>
                <div className="NewProject-header">
                  <div className="NewProject-title">
                    <span>New Project</span>
                  </div>
                  <div className="NewProject-actions">
                    <Button
                      color="primary"
                      onClick={this.props.history.goBack}
                    ><IconContentRemB style={{ marginRight: 8 }} /> Cancel</Button>
                  </div>
                </div>
                <div className="NewProject-content">
                  <Typography variant='h6' style={{ marginBottom: 16 + 'px' }}>Basic Information</Typography>
                  <div>
                    <Field
                      name="projectName"
                      validate={required}
                      component={TextFieldAdapter}
                      placeholder="Type anything"
                      label="Project Name"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="projectNumber"
                      validate={required}
                      component={TextFieldAdapter}
                      placeholder="Type anything"
                      label="Project Number"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="siteAddress"
                      validate={required}
                      component={TextFieldAdapter}
                      placeholder="Type anything"
                      label="Site Address"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="siteName"
                      validate={required}
                      component={TextFieldAdapter}
                      placeholder="Type anything"
                      label="Site Name"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="location"
                      validate={required}
                      component={TextFieldAdapter}
                      placeholder="Type anything"
                      label="Location"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="regionId"
                      validate={required}
                      component={SelectedFieldAdapter}
                      value={this.state.value}
                      placeholder="Type anything"
                      label="Region Id"
                      style={fieldStyle} >
                      {this._regionsItems(all_regions)}
                    </Field>
                  </div>

                  <Typography variant='h6' style={{ marginBottom: 16 + 'px' }}>Project Dates</Typography>

                  <div>
                    <Field
                      name="startDate"
                      validate={required}
                      component={DatePickerAdapter}
                      label="Start Date"
                      style={fieldStyle}
                    />
                  </div>
                  <div>
                    <Field
                      name="endDate"
                      validate={required}
                      component={DatePickerAdapter}
                      label="End Date"
                      style={fieldStyle}
                    />
                  </div>

                  <Typography variant='subtitle1' style={{ marginBottom: 8 + 'px' }}>Supervisors</Typography>
                  <div>
                    <FieldArray name="supervisors">
                      {({ fields }) =>

                        <Field
                          name="supervisors"
                          options={suggestions}
                          component={Supervisors}
                          placeholder="Type to search and add a supervisor"
                          validate={required}
                          onChange={(event, value) => {
                            if (value['action'] === 'select-option') {
                              push('supervisors', value['option']['value'])
                            }
                            else if (value['action'] === 'remove-value') {
                              fields.forEach((name, index) => {
                                if (fields['value'][index] === value['removedValue']['value']) {
                                  fields.remove(index)
                                }
                              })
                            }

                          }
                          }
                        />
                      }
                    </FieldArray>
                  </div>
                </div>
                <div className="NewProject-detailFooter">
                  <div className="buttons">
                    <Button variant="contained"
                      type="submit"
                      color="primary"
                      style={buttonStyle}
                      disabled={submitting || pristine}
                    ><IconContentSend style={{ marginRight: 8 }} />Submit</Button>

                    <Button variant="contained"
                      type="button"
                      color="secondary"
                      style={buttonStyle}
                      onClick={reset}
                      disabled={submitting || pristine}
                    ><IconContentReset style={{ marginRight: 8 }} /> Reset</Button>
                  </div>
                </div>
              </form>

            )}
          />
        </div>
      </Paper>

    );
  }
}

const submitProject = gql`
  mutation createProject($name: String!, $number: String!, $siteAddress: String!, $siteName: String!, $location: String!, $regionId: ID!, $startDate: Date!, $endDate: Date!, $creatorId: ID!) {
    createProject(input: {name: $name, number: $number, siteAddress:  $siteAddress, siteName: $siteName, location: $location, regionId: $regionId, startDate: $startDate, endDate: $endDate, creatorId: $creatorId}) {
      id
      name
    }
  }
`;

const submitProjectInvitation = gql`
  mutation createProjectInvitation($currentCreatedProjectId: ID!, $supervisorId: ID!){
    createProjectInvitation(input: {projectId: $currentCreatedProjectId, userId: $supervisorId, status: "SEND"}){
      id
      user{
        name
      }
    }
  }
`;

const ALL_REGIONS_QUERY = gql`
  query {
    regions {
      id
      name
    }

  }
`;

const ALL_SUPERVISORS_QUERY = gql`
  query {
    users(filters: [{field: "role_eq", operand: "Supervisor" }, {field:"active_eq", operand:"true"}]){
      id
      fullName
      role
      email
    }
  }
`;

// const ProfileWithData = graphql(ALL_REGIONS_QUERY, { name: 'all_regions_query' })(NewProjectForm);
export default compose(
  graphql(submitProject, { name: 'postMutation' }),
  graphql(submitProjectInvitation, { name: 'projectInvitationMutation' }),
  graphql(ALL_REGIONS_QUERY, { name: 'all_regions_query' }),
  graphql(ALL_SUPERVISORS_QUERY, { name: 'all_supervisors_query' })
)(NewProjectTmpForm);


// WEBPACK FOOTER //
// src/components/NewProjectTMP.js